import { render, staticRenderFns } from "./r-aviso-festivos.vue?vue&type=template&id=4111781c&scoped=true"
import script from "./r-aviso-festivos.vue?vue&type=script&lang=js"
export * from "./r-aviso-festivos.vue?vue&type=script&lang=js"
import style0 from "./r-aviso-festivos.vue?vue&type=style&index=0&id=4111781c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4111781c",
  null
  
)

export default component.exports